import './BetbookMaintenanceScreen.less';
import React from 'react';
import MaintenanceIcon from '../../icons/MaintenanceIcon';
import MaintenanceDarkIcon from '../../icons/MaintenanceDarkIcon';

interface MaintenanceInputs {
    title?: string;
    description?: string;
    isThemeDark?: boolean;
}

const BetbookMaintenanceScreen = ({ title, description, isThemeDark }: MaintenanceInputs) => {
    return (
        <>
            {isThemeDark ? <MaintenanceDarkIcon /> : <MaintenanceIcon />}
            <p className="c-black-70 maintenanceTitle">{title}</p>
            <p className="maintenanceDescription">{description}</p>
        </>
    );
};

export default BetbookMaintenanceScreen;
